import axios from "axios";
import secureLocalStorage from "react-secure-storage";



const createReminder = ( title, description,date, time, caseType, priority) => {
  const loginData = secureLocalStorage.getItem("loginCredentials");

    return new Promise((resolve , reject)=>{
          axios.post(
              `${process.env.REACT_APP_NODE_BASE_URL}/reminders/createReminder`,
              {
                userId: loginData.user.id,
                title: title,
                description: description,
                date: date,
                time:time ,
                caseType: caseType,
                priority

              }
            ).then((res)=>{
                resolve (res.data);
            }).catch(err=> reject(err) )
    })
 
};

const getAllReminders = ( ) => {
    const loginData = secureLocalStorage.getItem("loginCredentials");
  
      return new Promise((resolve , reject)=>{
            axios.get(
                `${process.env.REACT_APP_NODE_BASE_URL}/reminders/${loginData.user.id}/getAllReminders`
              ).then((res)=>{
                  resolve (res.data);
              }).catch(err=> reject(err) )
      })
   
  };

  const deleteReminder = ( reminderId) => {
    const loginData = secureLocalStorage.getItem("loginCredentials");
  
      return new Promise((resolve , reject)=>{
            axios.delete(
                `${process.env.REACT_APP_NODE_BASE_URL}/reminders/${loginData.user.id}/deleteReminder/${reminderId}`
              ).then((res)=>{
                  resolve (res.data);
              }).catch(err=> reject(err) )
      })
   
  };

export{
    createReminder,
    getAllReminders,
    deleteReminder
}